import React from "react";
import {PresentationPaneHeader, UnderlinedHeader} from "../../../components";
import {EstateFlowchartState} from "../../../EstateFlowchart/model/EstateFlowchartTypes";
import moment from "moment/moment";
import {useAppSelector} from "../../../store/hooks";
import {selectReleaseToggles} from "../../../ReleaseToggles/releaseTogglesSlice";

type DocumentsReviewedProps = {
    estateFlowchartStateData: EstateFlowchartState,
    index?: number
}

const DocumentsReviewed = ({estateFlowchartStateData, index}: DocumentsReviewedProps) => {

    const enableEstateFlowchartMVPRelease = useAppSelector(selectReleaseToggles)?.enableEstateFlowchartMVPRelease;

    return (<> <PresentationPaneHeader
            displayName={"ESTATE FLOWCHART"}
            callingFromDEFReport={true}
            title={`${estateFlowchartStateData.flowchartName} | ${index === 0 ? "Documents Reviewed" : "Documents Reviewed (continued)"}`}

        />
            <section
                className={enableEstateFlowchartMVPRelease ? "enable-mvp-release-documents-review-report-page" : "documents-review-report-page"}>
                <UnderlinedHeader
                    primaryText="Document Name"
                    rightAlignedContent={<span data-testid="date-created-text"
                                               className={""}> {"Date Created"} </span>}
                />

                {
                    <>
                        {estateFlowchartStateData.willSummary && (estateFlowchartStateData.willSummary.partnerWill || estateFlowchartStateData.willSummary.primaryWill) &&
                            <>
                                <div className="estate-item">
                                    {"Will"}
                                </div>
                                {estateFlowchartStateData.willSummary.primaryWill &&
                                    <div className={"estate-item-section"}>
                                        <div className="legal-name-creation-date-flex">
                                    <span className="bold-dot">
                                        {estateFlowchartStateData.willSummary.primaryWill.legalName}
                                    </span>
                                            <span className="creation-date">
                                        {moment(estateFlowchartStateData.willSummary.primaryWill.creationDate).format('MMMM DD, YYYY')}
                                    </span>
                                        </div>

                                        {estateFlowchartStateData.willSummary.primaryWill.recordOfAmendment &&
                                            <div className="record-of-amendments">
                                                Record of Amendments
                                            </div>}
                                        <p className="record-of-amendments-data">
                                            {estateFlowchartStateData.willSummary.primaryWill.recordOfAmendment}
                                        </p>
                                    </div>
                                }

                                    {estateFlowchartStateData.willSummary.partnerWill &&
                                        <div className={"estate-item-section"}>
                                            <div className="legal-name-creation-date-flex">
                                                    <span className="bold-dot">
                                                        {estateFlowchartStateData.willSummary.partnerWill.legalName}
                                                    </span>

                                                <span className="creation-date">
                                                        {moment(estateFlowchartStateData.willSummary.partnerWill.creationDate).format('MMMM DD, YYYY')}
                                                    </span>
                                            </div>

                                            {estateFlowchartStateData.willSummary.partnerWill.recordOfAmendment &&
                                                <div className="record-of-amendments">
                                                    Record of Amendments
                                                </div>
                                            }
                                            <p className="record-of-amendments-data">
                                                {estateFlowchartStateData.willSummary.partnerWill.recordOfAmendment}
                                            </p>
                                        </div>
                                    }
                            </>
                        }

                        {estateFlowchartStateData.revocableTrust &&
                            <>
                                <div className="estate-item">
                                    {"Revocable Trust"}
                                </div>

                                <div className={"estate-item-section"}>
                                    <div className="legal-name-creation-date-flex">
                                        <span className="bold-dot">
                                            {estateFlowchartStateData.revocableTrust.legalName}
                                        </span>
                                        <span className="creation-date">
                                            {moment(estateFlowchartStateData.revocableTrust.trustCreationDate).format('MMMM DD, YYYY')}
                                        </span>
                                    </div>

                                    {estateFlowchartStateData.revocableTrust.recordOfAmendment &&
                                        <div className="record-of-amendments">
                                            Record of Amendments
                                        </div>
                                    }
                                    <p className="record-of-amendments-data">
                                        {estateFlowchartStateData.revocableTrust.recordOfAmendment}
                                    </p>
                                </div>
                            </>
                        }
                        {estateFlowchartStateData.irrevocableTrusts && estateFlowchartStateData.irrevocableTrusts?.length > 0 &&
                            <>
                                <div className="estate-item">
                                    {`${index === 0 ? "Irrevocable Trust" : "Irrevocable Trust (continued)"}`}
                                </div>

                                {estateFlowchartStateData.irrevocableTrusts.map(irrevocableTrustData => (
                                    <div className={"estate-item-section"} key={irrevocableTrustData.trustId}>
                                        <div className="legal-name-creation-date-flex">
                                            <span className="bold-dot">
                                                {irrevocableTrustData.legalName}
                                            </span>
                                            <span className="creation-date">
                                                {moment(irrevocableTrustData.trustCreationDate).format('MMMM DD, YYYY')}
                                            </span>
                                        </div>

                                        {irrevocableTrustData.recordOfAmendment &&
                                            <div className="record-of-amendments">
                                                Record of Amendments
                                            </div>
                                        }
                                        <p className="record-of-amendments-data">
                                            {irrevocableTrustData.recordOfAmendment}
                                        </p>
                                    </div>

                                ))}
                            </>
                        }
                    </>
                }

            </section>
        </>
    )
}

export default DocumentsReviewed;
